import React from "react";
import cn from "classnames";
import { TEXT_CLASS_NAME } from "../Text";
import styles from "./Title2.module.scss";

type Props = {
  as?: keyof JSX.IntrinsicElements;
  className?: string;
} & React.HTMLAttributes<HTMLOrSVGElement>;

const Title2 = ({ as: As = "p", className, ...props }: Props) => (
  <As {...props} className={cn(TEXT_CLASS_NAME, styles.title2, className)} />
);

export default Title2;
